// extracted by mini-css-extract-plugin
export default {"details__section-head":"lsf-details__section-head","region-actions":"lsf-region-actions","region-actions__group":"lsf-region-actions__group","region-actions__group_align_left":"lsf-region-actions__group_align_left","region-actions__group_align_right":"lsf-region-actions__group_align_right","waiting":"lsf-waiting"};
    if(module.hot) {
      // 1653630374657
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  